import { createNavigation } from "next-intl/navigation";
import { routing } from "./routing";

// Wrappers de Link/redirect/usePathname/useRouter que respetan el locale
// activo. Importar SIEMPRE desde acá para que la navegación interna no
// pierda el prefijo de locale.
export const { Link, redirect, usePathname, useRouter, getPathname } =
  createNavigation(routing);
